import React, {Component} from 'react';
import {Toast,Modal,InputItem} from 'antd-mobile';
import BMap from "BMap";
import * as mapData from '../../../config/mapData'
import {
    cityGetPrice,
    changeAddress,txgetLocation,txsuggestion,getUserHotAddress,changeUserHotAddress,delUserHotAddress
} from '../../../service/homeService';
import "./style.less";
import connect from "react-redux/es/connect/connect";
import Lottie from "react-lottie";
import moment from "moment";

const userPosition = require('../../../common/image/userPosition.png');
let map,gc,poi,ls;

@connect(
    state => ({userInfo: state.userInfo})
)
export default class CitySelAddress extends Component {
    constructor(props) {
        super(props);
        this.state = {
            position: {top: 0, left: 0,},
            curTips: '',
            isError: false,
            endAddress:'请拖动地图选点',
            searchValue:'',
            poiList:[],
            poiListFlag:true,
            isStopped: false,
            modal:false,
            setaddressmodal:false,
            currentChange:'',
            cityhistoryData:{
                homeAddress:{address:''},
                companyAddress:{address:''},
                startAddress:[],
                endAddress:[],
            },
        };
    }
    componentDidMount() {
        let props = this.props.location.state;
        console.log(props)
        this.getAddress()
        const self = this;
        let center = new window.TMap.LatLng(props.startPoi.lat, props.startPoi.lng)
        map = new window.TMap.Map('mapContainer',{center:center});
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ZOOM);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.ROTATION);
        map.removeControl(window.TMap.constants.DEFAULT_CONTROL_ID.SCALE);
        map.on("panend",function(e){
            let location = map.getCenter().toString().replace(/\s/ig, '')
            self.setState({isStopped:true});
            let params = {
                source: 1,
                token: self.props.userInfo.token,
                data:{location:location.split(',')[0]+','+location.split(',')[1],get_poi:1}
            };
            txgetLocation(params).then((res)=>{
                let result = res.data.data.result
                if (result.poi_count > 0) {
                    let firstPoint = result.pois[0];
                    self.setData(self, firstPoint.title, firstPoint.location.lng, firstPoint.location.lat, true, 0,firstPoint.ad_info.adcode);
                }
                if (result.poi_count == 0 && result.address_component.street !== "") {
                    self.setData(self, result.address_component.street + result.address_component.street_number, result.location.lng, result.location.lat, true, 0,result.ad_info.adcode);
                }
                if (result.poi_count == 0 && result.address_component.street == "") {
                    self.setData(self, '坐标位置', result.location.lng, result.location.lat, true, 3,result.ad_info.adcode);
                }
                self.setState({ isStopped: false });
            })
        })
        // map = new BMap.Map('mapContainer');
        // gc = new BMap.Geocoder();
        // ls = new BMap.LocalSearch(map, {
        //     onSearchComplete: (res) => {
        //         let s = [];
        //         if(res){
        //             for (var i = 0; i < res.getCurrentNumPois(); i ++){
        //                 s.push(res.getPoi(i))
        //             }
        //             self.setState({
        //                 poiList: s,
        //             });
        //         }
        //     },
        // });
        // map.addEventListener('dragend', function (e) {
        //     self.setState({isStopped:true});
        //     gc.getLocation(e.point, function (res) {
        //         if (res.surroundingPois.length) {
        //             let firstPoint = res.surroundingPois[0];
        //             self.setData(self, firstPoint.title, firstPoint.point.lng, firstPoint.point.lat, true, 0);
        //             self.setState({poiList:res.surroundingPois,});
        //         } else {
        //             self.setData(self, '坐标位置', e.point.lng, e.point.lat, true, 3);
        //         }
        //         self.setState({isStopped:false});
        //     });
        // });
        // map.centerAndZoom(props.startCity, 15);
    }
    getAddress(){
        let params = {
            source: 1,
            token: this.props.userInfo.token,
        };
        getUserHotAddress(params).then((res)=>{
            this.setState({cityhistoryData:res.data.data})
        })
    }
    selPoi(res){
        console.log(res)
        const props = this.props.location.state;
        if(res.code){
            this.setData(this, res.address, res.location.split('_')[1], res.location.split('_')[0], true, 0,res.code);
        }else{
            this.setData(this, res.title, res.point.lng, res.point.lat, true, 0,res.adcode);
        }
        if(props.cityType === 'city'){
            this.cityGetPrice(props)
        }else if(props.cityType === 'cityChange'){
            this.cityChangeAddress(props)
        }
    }
    searchChange=(value)=>{
        const props = this.props.location.state;
        this.setState({ searchValue:value ,poiListFlag:true});
        this.tabDOM.scrollTop = 0;
        if(value){
            let params = {
                source: 1,
                token: this.props.userInfo.token,
                data:{location:props.startPoi.lat+','+props.startPoi.lng,keyword:value}
            };
            txsuggestion(params).then((res)=>{
                res.data.data.data.map((r)=>{
                    r.point = r.location
                })
                this.setState({poiList:res.data.data.data,});
            })
        }
        // ls.search(value);
    };
    onClear=()=>{
        this.setState({poiList: [],poiListFlag:false,searchValue:'',setaddressmodal:false});
    };

    setData = (self, title, lng, lat, boolean, index,adcode) => {
        self.setState({
            endAddress: title,
            isError: boolean,
            curTips: index == 0 ? title : "坐标位置",
        });
        poi = {
            lng: lng,
            lat: lat,
            endAddress: title,
            adcode:adcode,
        };
    };

    goSelClass(){
        if(this.state.endAddress === '' || this.state.endAddress === '请拖动地图选点'){
            Toast.info("请输入下车地址！");
            return
        }
        const props = this.props.location.state;
        if(props.cityType === 'city'){
            this.cityGetPrice(props)
        }else if(props.cityType === 'cityChange'){
            this.cityChangeAddress(props)
        }
    }
    cityGetPrice(props){
        let getPriceData = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                startLocation:props.startPoi.lat + "_" + props.startPoi.lng,
                endLocation :this.state.endAddress == "昆明市"? "25.082654_102.738151" : poi.lat + "_" + poi.lng,
                cityorderType:props.nowType,
                estimatedTimeOfDeparture:props.appointmentTime == '现在出发' ? '' : moment(props.appointmentTime).utcOffset(8).format(),
                startAddressCode:props.startPoi.adcode,
                endAddressCode:poi.adcode,
            }
        };
        //获取价格
        cityGetPrice(getPriceData).then((res)=>{
            if(res.data.code == '0000'){
                let params = {
                    startCity:props.startCity,
                    startAddress:props.startPoi.address,
                    startPosition:props.startPoi,
                    endPosition:poi,
                    endAddress:this.state.endAddress,
                    nowType:props.nowType,
                    appointmentTime:props.appointmentTime,
                    type:'address',
                    theoryPrice:res.data.data.totalPrice,
                    driverTime:res.data.data.driverTime,
                    driverDistance:res.data.data.driverDistance,
                    isFirstPay:res.data.data.isFirstPay,
                    cityId:res.data.data.cityId,
                    startAddressCode:res.data.data.startAddressCode,
                    endAddressCode:res.data.data.endAddressCode,
                    mark:true,
                };
                // if(res.data.data === true){
                //     Modal.alert('', <div>您有正在进行的城内订单，是否进入查看？</div>, [
                //         { text: '取消',style:{background:"#DADCDE",color:"#ACACAC",fontSize:"14px",height:"48px"}},
                //         { text: '进入',style:{background:"#3679FE",color:"#FFFFFF",fontSize:"14px",height:"48px"}, onPress: () => {
                //                 this.props.history.push('/rideCar');
                //             }},
                //     ]);
                // }else{
                //     if(res.data.data.isFirstPay == 1){
                //         this.props.history.push('/rideCar',params);
                //     }else{
                //         this.props.history.push('/rideCarPay',params);
                //     }
                // }
                if(res.data.data === false){
                    Toast.info("您有正在进行的城内订单",3);
                }else{
                    if(res.data.data.isFirstPay == 1){
                        this.props.history.push('/rideCar',params);
                    }else{
                        this.props.history.push('/rideCarPay',params);
                    }
                }
            }else{
                Toast.info(res.data.msg,3);
            }
        });
    }
    cityChangeAddress(props){
        let changeData = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                intercityOrderId :props.id,
                endAddress:this.state.endAddress,
                endAddressLocation  :this.state.endAddress == "昆明市" ? "25.082654_102.738151" : poi.lat + "_" + poi.lng,
                operatorType:3,
                sourceChange:3,
            }
        };
        changeAddress(changeData).then((res)=>{
            if(res.data.code == '0000'){
                this.props.history.push('/rideCar');
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    setoftenAddress(res){
        console.log(res)
        console.log(this.state.currentChange)
        let params = {
            source:1,
            token: this.props.userInfo.token,
            data: {
                address:res.title,
                location:res.point.lat+'_'+res.point.lng,
                code:res.adcode,
                type:this.state.currentChange == '家庭' ? 1 : 2,
            }
        };
        changeUserHotAddress(params).then((res)=>{
            if(res.data.code == '0000'){
                this.setState({setaddressmodal:false,poiList: [],searchValue:'',})
                this.getAddress()
                Toast.info('设置成功',3); 
            }else{
                Toast.info(res.data.msg,3);
            }
        })
    }
    render(){
        const props = this.props.location.state;
        const mapOptions = {
            loop: false,
            autoplay: true,
            animationData: mapData,
            rendererSettings: {
                preserveAspectRatio: 'xMidYMid slice'
            }
        };
        return(
            <div className="selAddress1">
                <div id="mapContainer"/>
                {this.state.isError ? <div className="errTips"><span>{this.state.curTips}</span></div> : null
                }
                <img
                    className="userPosition"
                    src={userPosition}
                    style={{top: this.state.position.top, left: this.state.position.left}}
                    alt=""
                />
                <Lottie
                    style={{position:"absolute",bottom:"50%",left:"50%",marginLeft: -14,zIndex:997}}
                    options={mapOptions}
                    height={52}
                    width={28}
                    isStopped={this.state.isStopped}
                    isPaused={this.state.isPaused}/>
                <div className="poiList" style={this.state.poiListFlag === false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                    <div className='setAddressbox' style={this.state.poiListFlag === false  ? {display:'none'} : null}>
                        <div className='setAddress'>
                            <div className='home flex'>
                                <i className="icon iconfont iconjiating"/>
                                <div className='text'>
                                    <p className='name'>家庭</p>
                                    <p className='address' onClick={()=>{
                                        if(this.state.cityhistoryData.homeAddress == null){
                                            this.setState({currentChange:'家庭',setaddressmodal:true,searchValue:'',poiList: [],})
                                        }else{
                                            this.selPoi(this.state.cityhistoryData.homeAddress)
                                        }
                                    }}>{this.state.cityhistoryData.homeAddress? this.state.cityhistoryData.homeAddress.address:'未设置家庭地址'}</p>
                                </div>
                                <i className="icon iconfont iconzhongjiansanyuan" onClick={()=>{
                                    if(this.state.cityhistoryData.homeAddress == null){
                                        this.setState({currentChange:'家庭',setaddressmodal:true,searchValue:'',poiList: [],})
                                    }else{
                                        this.setState({currentChange:'家庭',modal:true})
                                    }
                                }}/>
                            </div>
                            <div className='height'></div>
                            <div className='company flex'>
                                <i className="icon iconfont icongongsi"/>
                                <div className='text'>
                                    <p className='name'>公司</p>
                                    <p className='address' onClick={()=>{
                                        if(this.state.cityhistoryData.companyAddress == null){
                                            this.setState({currentChange:'公司',setaddressmodal:true,searchValue:'',poiList: [],})
                                        }else{
                                            this.selPoi(this.state.cityhistoryData.companyAddress)
                                        }
                                    }}>{this.state.cityhistoryData.companyAddress? this.state.cityhistoryData.companyAddress.address:'未设置公司地址'}</p>
                                </div>
                                <i className="icon iconfont iconzhongjiansanyuan" onClick={()=>{
                                    if(this.state.cityhistoryData.companyAddress == null){
                                        this.setState({currentChange:'公司',setaddressmodal:true,searchValue:'',poiList: [],})
                                    }else{
                                        this.setState({currentChange:'公司',modal:true})
                                    }
                                }}/>
                            </div>
                        </div>
                        <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                    </div>
                    <div className="list1">
                        {
                            this.state.cityhistoryData.endAddress.map((res, i) => (
                                <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                    <i className="icon iconfont iconlishi"/>
                                    <div>
                                        <div>{res.title}</div>
                                        <span>{res.address}</span>
                                    </div>
                                </div>

                            ))
                        }
                    </div>
                    {
                        this.state.poiList.length > 0 ? (
                            <div className="list">
                                {
                                    this.state.poiList.map((res, i) => (
                                        <div className="item"  key={i}  onClick={() => this.selPoi(res)} >
                                            <i className="icon iconfont icondituliebiaotubiao"/>
                                            <div>
                                                <div>{res.title}</div>
                                                <span>{res.address}</span>
                                            </div>
                                        </div>

                                    ))
                                }
                            </div>
                        ): <div className='tishi'>请输入搜索内容</div>
                    }

                </div>

                <div className="topBar">
                    <div className='box'>
                        <i className="icon iconfont iconfanhui" onClick={() => this.props.history.goBack()} />
                        <div className='circleS'></div>
                        <InputItem
                            className="searchBar"
                            ref={ref => this.autoFocusInst = ref}
                            value={this.state.searchValue}
                            placeholder="请输入终点"
                            onChange={this.searchChange}
                        ></InputItem>
                    </div>
                </div>
                <div className="bottom">
                   <div className="addressText">
                       {props.type === 'start' ? <i className="icon iconfont iconchufadi"/> : <i className="icon iconfont iconmudedi"/>}
                       <p>{this.state.endAddress}</p>
                   </div>
                    <div className="btn"><button onClick={()=>this.goSelClass()}>去打车</button></div>
                </div>
                <Modal
                    className="modalClass"
                    animationType="slide-up"
                    popup
                    // maskClosable={false}
                    visible={this.state.modal}
                    onClose={()=>{this.setState({modal:false})}}
                >
                    <div className="content1">
                        <div className='first'onClick={()=>{
                            this.setState({setaddressmodal:true,searchValue:'',poiList: [],modal:false})
                        }}>修改{this.state.currentChange}地址</div>
                        <div onClick={()=>{
                            let params = {
                                source:1,
                                token: this.props.userInfo.token,
                                data: {type:this.state.currentChange == '家庭' ? 1 : 2,}
                            };
                            delUserHotAddress(params).then((res)=>{
                                if(res.data.code == '0000'){
                                    this.setState({modal:false})
                                    this.getAddress()
                                    Toast.info('删除成功',3);
                                }else{
                                    Toast.info(res.data.msg,3);
                                }
                            })
                        }}>删除{this.state.currentChange}地址</div>
                        <div className='cancel' onClick={()=>{this.setState({modal:false})}}>取消</div>
                    </div>
                </Modal> 
                <Modal
                    className="seraddressmodalClass"
                    animationType="slide-up"
                    // maskClosable={false}
                    visible={this.state.setaddressmodal}
                    onClose={()=>{this.setState({setaddressmodal:false})}}
                >
                    <div className="content1">
                        <div className="topBar">
                            <div className='box'>
                                <i className="icon iconfont iconfanhui" onClick={() =>{
                                     this.setState({setaddressmodal:false,poiList: [],searchValue:'',})
                                }} />
                                <InputItem
                                    className="searchBar"
                                    ref={ref => this.autoFocusInst = ref}
                                    value={this.state.searchValue}
                                    placeholder={`设置${this.state.currentChange}地址`}
                                    onChange={this.searchChange}
                                ></InputItem>
                            </div>
                        </div>
                        <div className="poiList" style={this.state.poiListFlag === false  ? {height:'0'} : {height:'100%'}} ref={dom => {this.tabDOM = dom}}>
                            {/* <div>
                                <div className="mapSel" onClick={this.onClear}><i className="icon iconfont iconditushangxuandian"/>在地图上选点</div>
                            </div> */}
                            {
                                this.state.poiList.length > 0 ? (
                                    <div className="list">
                                        {
                                            this.state.poiList.map((res, i) => (
                                                <div className="item"  key={i}  onClick={() => this.setoftenAddress(res)} >
                                                    <i className="icon iconfont icondituliebiaotubiao"/>
                                                    <div>
                                                        <div>{res.title}</div>
                                                        <span>{res.address}</span>
                                                    </div>
                                                </div>

                                            ))
                                        }
                                    </div>
                                ): <div className='tishi'>请输入搜索内容</div>
                            }
                        </div>
                    </div>
                </Modal>    
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Home/CitySelAddress/index.js